import * as ActionTypes from '../constants/ActionTypes';

const initialState = () => ({
    i18n: {},
    allLanguages: ['es', 'en', 'ru'],
    currentLanguage: {}
});

export default (state = initialState(), action) => {
    switch (action.type) {
        case ActionTypes.SET_ALL_LANGUAGES:
            return {...state, allLanguages: action.payload};
        case ActionTypes.SET_CURRENT_LANGUAGE:
            return {...state, currentLanguage: action.payload};
        case ActionTypes.SET_I18N:
            return {...state, i18n: action.payload};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/Languages.js